import styled from 'styled-components';

export const LeftPanelPageBaseStyle = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
  `,
  MainContentBox: styled.div`
    flex: 1;
    display: flex;
  `,
  RightContentBox: styled.div`
    flex: 1;
    position: relative;
    height: calc(100vh - 56px);
    overflow-y: overlay;
  `,
  RightContentScroll: styled.div`
    min-height: 100%;
  `,
  Scroll: styled.div`
    min-height: calc(100vh - 56px);
    overflow-y: overlay;
    height: 100%;
    max-height: 100%;
    @media screen and (min-height: 672px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  `,
  RightContent: styled.div<{ $rightWidth: 'normal' | 'wide' }>`
    max-width: ${({ $rightWidth }) => ($rightWidth === 'normal' ? '400px' : '800px')};
    margin: 72px auto;
  `,
};
